import React, { useEffect, useState, useRef, PureComponent, useContext } from 'react';
import { useParams, useLocation } from 'react-router-dom';

import {
    PieChart, Pie, Sector, Cell
} from "recharts";

import { QRCodeSVG } from 'qrcode.react';

import Header from "../Header";
import Footer from "../Footer";
import Preview from "../Preview";
import PublishButton from "../PublishButton";
import Page404 from "./Page404";

import AirdropsList from "../AirdropsList";
import Airdrop from "../Airdrop";
import AirdropAll from "../AirdropAll";

import Performance from "../Performance";
import Periods from "../Periods";

import NotificationsList from "../NotificationsList";
import Notification from "../Notification";
import NotificationAll from "../NotificationAll";

import QRCodeModal from "../QR";
import QRCodeModalAnalytics from "../QRAnalytics";

import { ReactComponent as EditPurpleSvg } from '../../assets/edit_purple.svg';
import { ReactComponent as GenerateSvg } from '../../assets/generate.svg';
import { ReactComponent as SendSvg } from '../../assets/send.svg';
import { ReactComponent as CheckboxSvg } from '../../assets/checkbox.svg';

import module from '../../assets/module.svg';
import rocket from '../../assets/rocket.png';
import user from '../../assets/user.png';

import questions from '../../assets/questions.png';
import video from '../../assets/video.png';
import download from '../../assets/download.png';
import profile from '../../assets/module_profile.png';

import Resizer from "react-image-file-resizer";
import { db, storage } from "../../firebase";
import { ref, getDownloadURL, uploadBytesResumable, deleteObject, uploadString } from "firebase/storage";
import { doc, getDocs, getDoc, collection, onSnapshot, setDoc, updateDoc, addDoc, query, orderBy, where } from "firebase/firestore";

import { useForm } from "react-hook-form";

import { useNavigate } from 'react-router-dom';

import { smartDateFormatTimestamp } from "../../utils/functions";

import axios from 'axios';

import { AuthContext } from '../../context/AuthContext';
import { ProjectsContext } from '../../context/ProjectsContext';

export default function Project() {

    const { projects } = useContext(ProjectsContext);

    const { currentUser, user } = useContext(AuthContext);

    const [result, setResult] = useState('');

    const [project, setProject] = useState(false);

    //===

    const Save = async (data) => {
        console.log('Save');

        setProject(Object.assign(project, data));

        const ref = await doc(db, "projects", projectID);
        await updateDoc(ref, project);
    }
    const [projectID, setProjectID] = useState(false);
    const params = useParams();
    const setPageProps = async () => {

        if (!!params.id) {

            let projectID = params.id;
            setProjectID(projectID);

            for (let key in projects) {
                if (projects[key]['id'] == projectID) {

                    let project = projects[key];

                    //console.log('project');
                    //console.log(project);

                    if (!project['AIRDROPS'])
                        project['AIRDROPS'] = [];

                    if (!project['notifications'])
                        project['notifications'] = [];

                    setProject(project);

                }
            }

            /*
            let projectID = params.id;
            setProjectID(projectID);

            console.log(projectID);

            if (projectID) {
                let snap = await getDoc(doc(db, "projects", projectID));

                let project = snap.data();
                if (!project['AIRDROPS'])
                    project['AIRDROPS'] = [];

                if (!project['notifications'])
                    project['notifications'] = [];

                console.log('project data');
                console.log(project);


                setProject(project);
            }
            */



        }
        //<Page404 text="Project not found" />
    };

    const qrOptions = {
        dotsOptions: {
            color: "#426ff5",
            type: "rounded"
        },
        backgroundOptions: {
            color: "#e9ecef",
        }
    };


    useEffect(() => {

        setPageProps();

    }, [projects]);

    const navigate = useNavigate();

    const piechart = [
        { name: 'iOS', value: 60 },
        { name: 'Android', value: 25 },
        { name: 'Whindows', value: 15 },
    ];
    const piechartColors = ['#D084FF', '#911BD9', '#B63FFF'];




    /*** Download image ***/

    const [message, changeMessage] = useState('');
    const setMessage = (text) => {
        changeMessage(text)
        setTimeout(() => {
            changeMessage();
        }, 3000);
    };

    const LoadImageFirebase = async (file, new_name, airdropID) => {

        //console.log('-------');
        //console.log(file);
        //console.log(new_name);

        const extension = file.name.split('.').pop();

        //file = await resizeFile(file);

        //const storageRef = ref(storage, `airbase/${new_name}.${extension}`);
        const storageRef = ref(storage, `airdrops/${new_name}.png`);

        const uploadTask = uploadBytesResumable(storageRef, file);


        uploadTask.on("state_changed",
            (snapshot) => {

            },
            (error) => {

                //console.log('-------2');

                setMessage("Can't upload file. " + error);
                return;

            },
            () => {

                //console.log('-------3');

                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

                    //console.log('-------4');

                    //console.log(downloadURL);

                    project['AIRDROPS'][airdropID]['image'] = downloadURL;

                    setProject(project);



                    updateProjectFirebase(project['ID']);


                });
            }
        );

    }

    const resizeFile = (file) =>
        new Promise((resolve) => {

            const extension = file.name.split('.').pop();
            Resizer.imageFileResizer(
                file,
                300,
                300,
                "PNG",
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64"
            );
        });


    const updateProjectFirebase = async () => {
        console.log('Updating project in Firebase');
        console.log('Project data:', JSON.parse(JSON.stringify(project))); // Deep clone to remove any non-serializable data

        const cleanProject = JSON.parse(JSON.stringify(project));

        // Remove any undefined values
        Object.keys(cleanProject).forEach(key =>
            cleanProject[key] === undefined && delete cleanProject[key]
        );

        const ref = doc(db, "projects", projectID);
        try {
            await updateDoc(ref, cleanProject);
            console.log('Project updated successfully');
        } catch (error) {
            console.error('Error updating project:', error);
            throw error;
        }
    }

    /*** Airdrop ***/

    const [isAirdrop, setShowAirdrop] = useState(false);
    const saveAirdrop = async (data) => {
        console.log('Saving airdrop with data:', data);

        if (!data.users || data.users.length === 0) {
            console.error('No users selected for airdrop. Aborting.');
            return;
        }

        let airdropID = project['AIRDROPS'].length;

        // Prepare airdrop data
        let airdropData = {
            name: data.name || '',
            description: data.description || '',
            allUsers: data.filterType === 'all',
            filterType: data.filterType || 'all',
            minPoints: data.filterType === 'minPoints' ? Number(data.minPoints) || 0 : null,
            maxPoints: data.filterType === 'maxPoints' ? Number(data.maxPoints) || 0 : null,
            selectedActivity: data.filterType === 'activity' ? data.selectedActivity || null : null,
        };

        // Remove any properties with undefined values
        Object.keys(airdropData).forEach(key => airdropData[key] === undefined && delete airdropData[key]);

        console.log('Prepared airdrop data:', airdropData);

        project['AIRDROPS'][airdropID] = airdropData;

        // Handle image upload
        if (data.image) {
            try {
                await LoadImageFirebase(data.image, `airdrop_${projectID}_${airdropID}`, airdropID);
                console.log('Image uploaded successfully');
            } catch (error) {
                console.error('Error uploading airdrop image:', error);
                setMessage("Can't upload airdrop image. " + error);
                return;
            }
        }

        // Assign airdrop to selected users
        for (let userId of data.users) {
            try {
                let ref = doc(db, "users", userId);
                let snap = await getDoc(ref);
                let user = snap.data();

                if (user && user.project_id === project.id) {
                    if (!user['AIRDROPS']) {
                        user['AIRDROPS'] = [];
                    }

                    user['AIRDROPS'].push({
                        projectID: projectID,
                        airdropID: airdropID,
                    });

                    await updateDoc(ref, user);
                    console.log(`Airdrop assigned to user ${userId} for project ${project.id}`);
                } else {
                    console.warn(`User ${userId} not found or not part of project ${project.id}. Skipping.`);
                }
            } catch (error) {
                console.error(`Error assigning airdrop to user ${userId}:`, error);
            }
        }

        // Update the project with the new airdrop
        try {
            console.log('Updating project with new airdrop:', project['AIRDROPS']);
            await updateProjectFirebase();
            console.log('Project updated with new airdrop');
        } catch (error) {
            console.error('Error updating project with new airdrop:', error);
            throw error; // Re-throw the error to be caught by the caller
        }

        console.log('Airdrop save process completed');
        setProject({ ...project }); // Trigger a re-render
    }
    const showAirdrop = event => {
        setShowAirdrop(true);
        document.body.classList.add('fixed');
    }
    const hideAirdrop = event => {
        setShowAirdrop(false);
        document.body.classList.remove('fixed');
    }

    /*** Airdrop All ***/

    const [isAirdropAll, setShowAirdropAll] = useState(false);

    const saveAirdropAll = async (data) => {

        let airdropID = project['AIRDROPS'].length;
        project['AIRDROPS'][airdropID] = data;

        console.log(data);

        LoadImageFirebase(data['image'], projectID + '_' + airdropID, airdropID);

        //console.log(project);

        //console.log('@@@');
        //console.log(data);
        //console.log(data['users']);

        const ref = collection(db, "users");
        const q = query(ref);
        const snapshot = await getDocs(q);
        const users = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));


        for (let key in users) {

            let user = users[key];
            if (user) {
                if (!user['AIRDROPS'])
                    user['AIRDROPS'] = [];

                //console.log(user);

                user['AIRDROPS'].push({
                    projectID: projectID,
                    airdropID: airdropID,
                });

                console.log(user);

                const ref = await doc(db, "users", user.id);
                await updateDoc(ref, user);
            }

        }

    }
    const showAirdropAll = event => {
        setShowAirdropAll(true);
        document.body.classList.add('fixed');
    }
    const hideAirdropAll = event => {
        setShowAirdropAll(false);
        document.body.classList.remove('fixed');
    }

    /*** Airdrops List ***/

    const [isAirdropsList, setShowAirdropsList] = useState(false);

    const showAirdropsList = event => {
        setShowAirdropsList(true);
        document.body.classList.add('fixed');
    }
    const hideAirdropsList = event => {
        setShowAirdropsList(false);
        document.body.classList.remove('fixed');
    }

    const [users, setUsers] = useState([]);
    let num = 0;
    /*
    
        useEffect(() => {
    
            console.log('users');
    
            console.log(projects);
    
            // get project users
    
             for(let key in projects){
                let project = projects[key];
                if(projects[key]['id'] == projectID && project['usersList']){
    
                    let users = project['usersList'];
                    users = [].concat(users).sort((a, b) => {
                            a = a['score'];
                            b = b['score'];
                            return b - a;
                    });
                    setUsers(users);
                }
            }
        }, [projects, project, project['usersList']]);
    */

    useEffect(() => {

        // we came from the another page and the users are already counted
        let users = false;
        for (let key in projects) {
            let project = projects[key];
            if (projects[key]['id'] == projectID && project['usersList']) {

                users = project['usersList'];
                users = [].concat(users).sort((a, b) => {
                    a = a['score'];
                    b = b['score'];
                    return b - a;
                });
                setUsers(users);
            }
        }

        // no user data yet
        if (!users) {

            const unsub = onSnapshot(
                query(collection(db, "users"), orderBy("score", "desc")),
                (snapshot) => {

                    let users = [];
                    let items = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
                    for (let key in items) {
                        if (items[key].progress && projectID && items[key].progress[projectID])
                            users.push(items[key]);
                    }
                    setUsers(users);
                }
            );
            return () => unsub();
        }

    }, [projectID]);

    /*
        useEffect(() => {
    
                const unsub = onSnapshot(
                    query(collection(db, "users"), orderBy("score", "desc")),
                    (snapshot) => {
    
                     let users = [];
                        let items = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
                        for (let key in items){
                            if (items[key].progress && projectID && items[key].progress[projectID])
                                users.push(items[key]);
                        }
                        setUsers(users);
                    }
                );
                return () => unsub();
          }, [project]);
    */


    /*** Notification ***/


    const sendEmail = async (to, subject, html) => {

        await addDoc(collection(db, "mail"), {
            to: to,
            message: {
                subject: subject,
                html: html,
            },
        });
    };

    const sendText = async (phone, sms) => {
        const newText = addDoc(collection(db, "sms"), {
            to: phone,
            body: sms,
        }).then((docRef) => {
            //console.log(docRef);
        });
    };

    const [isNotification, setShowNotification] = useState(false);
    const saveNotification = async (data) => {

        console.log(data);

        let notificationID = project['notifications'].length;
        project['notifications'][notificationID] = data;
        setProject(project);
        updateProjectFirebase(project['ID']);



        for (let key in data['users']) {

            let ref = await doc(db, "users", data['users'][key]);
            let snap = await getDoc(ref);
            let user = snap.data();

            if (user.corporateEmail && data.email.subject != '' && data.email.html != '') {
                sendEmail(user.corporateEmail, data.email.subject, data.email.html);
            }
            if (user.phone && data.sms != '') {
                sendText(user.phone, data.sms);
            }
        }

    }
    const showNotification = event => {
        setShowNotification(true);
        document.body.classList.add('fixed');
    }
    const hideNotification = event => {
        setShowNotification(false);
        document.body.classList.remove('fixed');
    }

    /*** Notification All ***/

    const [isNotificationAll, setShowNotificationAll] = useState(false);

    const saveNotificationAll = async (data) => {

        console.log(data);

        let notificationID = project['notifications'].length;
        project['notifications'][notificationID] = data;
        setProject(project);
        updateProjectFirebase(project['ID']);

        for (let key in users) {

            let user = users[key];

            if (user.email && data.email.subject != '' && data.email.html != '') {
                sendEmail(user.email, data.email.subject, data.email.html);
            }
            if (user.phone && data.sms != '') {
                sendText(user.phone, data.sms);
            }
        }


    }
    const showNotificationAll = event => {
        setShowNotificationAll(true);
        document.body.classList.add('fixed');
    }
    const hideNotificationAll = event => {
        setShowNotificationAll(false);
        document.body.classList.remove('fixed');
    }

    /*** Notifications List ***/

    const [isNotificationsList, setShowNotificationsList] = useState(false);

    const showNotificationsList = event => {
        setShowNotificationsList(true);
        document.body.classList.add('fixed');
    }
    const hideNotificationsList = event => {
        setShowNotificationsList(false);
        document.body.classList.remove('fixed');
    }

    //==============================
    // QR CODE

    const [isQRCode, setShowQRCode] = useState(false);
    const site = process.env.REACT_APP_DEMO_SITE;
    const [link, setLink] = useState(site + projectID);
    // const [link, setLink] = useState(site + '#/' + projectID);
    const [savedQR, setSavedQR] = useState(null);
    const savedQRRef = useRef(null);

    useEffect(() => {
        if (savedQR) {
            // clear old QR code
            savedQRRef.current.innerHTML = '';

            savedQR.append(savedQRRef.current);
        }
    }, [savedQR]);

    const showQRCode = () => {
        setShowQRCode(true);
        document.body.classList.add('fixed');
    }

    const hideQRCode = () => {
        setShowQRCode(false);
        document.body.classList.remove('fixed');
    }

    useEffect(() => {
        // setLink(site + '#/' + projectID);
        setLink(site + projectID);
    }, [projectID]);

    //===============================
    // QR code Analytics

    const [isQRCodeAnalytics, setShowQRCodeAnalytics] = useState(false);

    const showQRCodeAnalytics = () => {

        console.log('show');
        document.body.classList.add('fixed');

        setShowQRCodeAnalytics(true);
    }
    const hideQRCodeAnalytics = () => {
        console.log('hide');
        setShowQRCodeAnalytics(false);
        document.body.classList.remove('fixed');
    }
    const saveQRCodeAnalytics = async (QRCode) => {

        QRCode.svg = await saveQRCodeSvg(QRCode.svg, projectID);

        project.QRCode = QRCode;
        setProject(Object.assign(project));

        if (QRCode && QRCode.svg && projectID) {

            const project_ref = await doc(db, "projects", projectID);
            await updateDoc(project_ref, {
                QRCode: QRCode
            });
        }
    }
    const saveQRCodeSvg = async (svg, projectID) => {

        const storageRef = ref(storage, `qrcode/${projectID}.svg`);
        const metadata = { contentType: "image/svg+xml" };

        var svg = new Blob([svg], {
            type: 'image/svg+xml'
        });

        await uploadBytesResumable(storageRef, svg);//, metadata

        return await getDownloadURL(storageRef);

    }

    const [QRCodeAnalytics, setQRCodeAnalytics] = useState([]);
    const getQRCodeCount = async (id) => {
        const url = 'https://lagoon-qr-tracker.james-0cc.workers.dev/qr_activity';
        const data = {
            id: id,
        }
        console.log(data);

        return await axios.post(url, data).then((res) => {

            console.log('QRCodeAnalytics');
            console.log(res.data);
            console.log(res.data.count);

            return res.data;


        }).catch((e) => {

            console.log(e);

        });
    }

    const getQRCodeAnalytics = async () => {

        let temp = [];
        if (project.QRCode && project.QRCode.id) {

            let res = await getQRCodeCount(project.QRCode.id);

            temp.push({
                name: 'Project ' + project.name,
                count: res.count,
                results: res.results,
            });
        }

        for (let packetIndex in project["PACKETS"]) {
            let packet = project["PACKETS"][packetIndex];
            if (packet.QRCode && packet.QRCode.id) {

                let res = await getQRCodeCount(packet.QRCode.id);

                temp.push({
                    name: packet.name,
                    count: res.count,
                    results: res.results,
                });
            }

            for (let activityIndex in packet['activities']) {
                let activity = packet['activities'][activityIndex];
                if (activity.QRCode && activity.QRCode.id) {

                    let res = await getQRCodeCount(activity.QRCode.id);

                    temp.push({
                        name: activity.name,
                        count: res.count,
                        results: res.results,
                    });
                }
            }
        }

        //console.log(temp);
        setQRCodeAnalytics(temp);
    }

    useEffect(() => {

        getQRCodeAnalytics();

    }, [project]);

    const [isShowMore, setShowMore] = useState([]);
    const toggleShowMore = (index) => {
        let temp = isShowMore;
        temp[index] = !temp[index];
        setShowMore([...temp]);
    }

    //==============================
    // Analytics

    const [analytics, setAnalytics] = useState(false);
    const [lastActivity, setLastActivity] = useState('');

    const [activityCount, setActivityCount] = useState(false);
    const [userCount, setUserCount] = useState(false);

    const getAnalytics = async () => {

        if (projectID) {
            const ref = collection(db, "actions");
            const q = query(ref, where('project_id', '==', projectID), orderBy('timestamp', 'desc'));
            let snap = await getDocs(q);
            let analytics = snap.docs.map((doc) => ({ ...doc.data() }));

            setAnalytics(analytics);

            /*
            var max = 0;
            for (let key in analytics) {

                let item = analytics[key];
                if (item.timestamp.seconds > max) {
                    max = item.timestamp.seconds;
                }
            }

            if (max > 9)
                setLastActivity (smartDateFormatTimestamp(max));

            setActivityCount(analytics.length);

            console.log('analytics');
            console.log(analytics);


            let temp = new Set();
            for (let key in analytics) {
                let item = analytics[key];
                temp.add(item.user_id);
            }
            console.log('users');
            console.log(temp);
            console.log(temp.size);
            setUserCount(temp.size);
            */
        }
    }
    useEffect(() => {

        getAnalytics();

    }, [projectID]);

    useEffect(() => {

        if (project['analytics']) {
            //console.log('analytics');
            //console.log(project['analytics']);
            if (smartDateFormatTimestamp(project['analytics']['last_activity'].seconds) > 0)
                setLastActivity(smartDateFormatTimestamp(project['analytics']['last_activity'].seconds));
            setActivityCount(project['analytics']['user_activities']);
            setUserCount(project['analytics']['users'].length);
        }

    }, [project, project['analytics']]);


    //==============================
    // Scroll to anchor

    const { hash } = useLocation();
    useEffect(() => {
        //console.log('hash='+hash);
        if (hash !== '') {
            const id = hash.replace('#', '');
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView();
            }
        }
    }, [project]);

    return (

        <div className="page page_project">

            <Header />

            {project ?

                <main>
                    <div className="content">

                        <ul className="breadcrumbs">
                            <li>
                                <a href="/">Home</a>
                            </li>
                            <li>
                                <a href="/">Event</a>
                            </li>
                            <li>
                                <span>{project ? project['name'] : ''}</span>
                            </li>
                        </ul>

                        <div className="page__title">
                            <h1>{project ? project['name'] : ''}</h1>
                            <div className="title__buttons">

                                <a className="button" onClick={() => { navigate("/analytics/" + projectID) }}>Analytics</a>

                                <PublishButton project_status={project['status']} Save={Save} />

                                <a className="button button_edit" onClick={() => { navigate("/edit/" + projectID) }}>Edit project</a>
                            </div>
                        </div>

                        <div className="columns">
                            <div className="column">
                                <section className="section_activities">
                                    <a className="action edit" onClick={() => { navigate("/edit/" + projectID) }}>
                                        <EditPurpleSvg />
                                        Edit project
                                    </a>
                                    <h2>Activities</h2>
                                    <div className="subtitle">Preview</div>

                                    <Preview project={project} />

                                </section>
                            </div>
                            <div className="column">
                                <div className="row">
                                    <section className="section_qrcode">
                                        <h2>Control Panel</h2>
                                        {/* <div className="action">
                                            <GenerateSvg />
                                            Generate QR codes
                                        </div> */}

                                        {user.email &&
                                            (
                                                user.account == 'premium' ?

                                                    <div className="button_border button_wrap" onClick={showQRCodeAnalytics}>
                                                        Generate QR Code with analytcs
                                                    </div>

                                                    :

                                                    <div className="button_border" onClick={showQRCode}>
                                                        Generate QR Code
                                                    </div>
                                            )
                                        }



                                        {/* {isQRCode &&
                                            <QRCodeModal
                                                hideQRCode={hideQRCode}
                                                defaultLink={link}
                                                onSave={setSavedQR}
                                            />
                                        } */}
                                        <div className="generate-qrcode">

                                            {isQRCode &&
                                                <QRCodeModal
                                                    hideQRCode={hideQRCode}
                                                    defaultLink={link}
                                                    onSave={setSavedQR}
                                                />
                                            }
                                            {isQRCodeAnalytics &&
                                                <QRCodeModalAnalytics
                                                    hideQRCodeAnalytics={hideQRCodeAnalytics}
                                                    defaultLink={project['QRCode'] ? project['QRCode'].link : link}
                                                    QRCodeDefault={project.QRCode}
                                                    name={project ? project['name'] : ''}
                                                    saveQRCodeAnalytics={saveQRCodeAnalytics}
                                                    QRCodePropertiesDefault={project.QRCode}
                                                />
                                            }

                                            {project.QRCode && project.QRCode.png ?

                                                <div className="saved-qr-code-container">

                                                    <div className="qr__title">
                                                        QR code with analytics
                                                    </div>
                                                    <img src={project.QRCode.svg} />
                                                </div>

                                                :

                                                savedQR ?
                                                    <div className="saved-qr-code-container" ref={savedQRRef}></div>
                                                    :
                                                    <QRCodeSVG value="lagoon.com" />
                                            }

                                        </div>

                                    </section>
                                    <section className="section_airdrop">
                                        <div>
                                            <h2>Send airdrop</h2>
                                            <div className="buttons">
                                                <div className="button_border" onClick={showAirdrop}>
                                                    <SendSvg />
                                                    Send airdrop to a user
                                                </div>

                                                {isAirdrop ?

                                                    <Airdrop saveAirdrop={saveAirdrop} hideAirdrop={hideAirdrop} project={project} />
                                                    :
                                                    null
                                                }

                                                <div className="button_border" onClick={showAirdropAll}>
                                                    <SendSvg />
                                                    Send an airdrop to users
                                                </div>

                                                {isAirdropAll ?

                                                    <AirdropAll saveAirdropAll={saveAirdropAll} hideAirdropAll={hideAirdropAll} project={project} />
                                                    :
                                                    null
                                                }

                                                <div className="button_border" onClick={showAirdropsList}>
                                                    <CheckboxSvg />
                                                    Airdrops list
                                                </div>

                                                {isAirdropsList ?

                                                    <AirdropsList hideAirdropsList={hideAirdropsList} airdrops={project['AIRDROPS']} />
                                                    :
                                                    null
                                                }

                                            </div>
                                        </div>
                                        <div className="image">
                                            <img src={rocket} alt="" />
                                        </div>
                                    </section>
                                </div>

                                <section className="section_notifications">
                                    <div>
                                        <h2>Send notification</h2>
                                        <div className="buttons">
                                            <div className="button_border" onClick={showNotification}>
                                                <SendSvg />
                                                Send to a user
                                            </div>

                                            {isNotification ?

                                                <Notification saveNotification={saveNotification} hideNotification={hideNotification} projectID={projectID} />
                                                :
                                                null
                                            }

                                            <div className="button_border" onClick={showNotificationAll}>
                                                <SendSvg />
                                                Send to all users
                                            </div>

                                            {isNotificationAll ?

                                                <NotificationAll saveNotificationAll={saveNotificationAll} hideNotificationAll={hideNotificationAll} />
                                                :
                                                null
                                            }

                                            <div className="button_border" onClick={showNotificationsList}>
                                                <CheckboxSvg />
                                                Notifications list
                                            </div>

                                            {isNotificationsList ?

                                                <NotificationsList hideNotificationsList={hideNotificationsList} notifications={project['notifications']} />
                                                :
                                                null
                                            }

                                        </div>
                                    </div>
                                </section>

                                <a id="performance"></a>

                                <section className="performance">

                                    {analytics && <Performance analytics={analytics} />}

                                    {analytics && (
                                        <div className="subsection analytics-overview">
                                            <div className="metrics-grid">
                                                <div className="metric-box">
                                                    <div className="metric-title">Total Users</div>
                                                    <div className="metric-value">{userCount}</div>
                                                    <div className="metric-icon users-icon"></div>
                                                </div>
                                                
                                                <div className="metric-box">
                                                    <div className="metric-title">Completed Activities</div>
                                                    <div className="metric-value">{activityCount}</div>
                                                    <div className="metric-icon activities-icon"></div>
                                                </div>
                                                
                                                <div className="metric-box">
                                                    <div className="metric-title">APU</div>
                                                    <div className="metric-value">
                                                        {userCount ? (activityCount / userCount).toFixed(1) : 0}
                                                    </div>
                                                    <div className="metric-subtitle">Activities per user</div>
                                                    <div className="metric-icon apu-icon"></div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="row">
                                        <div className="subsection periods">
                                            {analytics && <Periods analytics={analytics} />}
                                        </div>
                                        {/* {activityCount !== false && (
                                            <div className="subsection analytics-overview">
                                                <div className="metrics-grid">
                                                    <div className="metric-box">
                                                        <div className="metric-title">Total Users</div>
                                                        <div className="metric-value">{userCount}</div>
                                                        <div className="metric-icon users-icon"></div>
                                                    </div>
                                                    
                                                    <div className="metric-box">
                                                        <div className="metric-title">Completed Activities</div>
                                                        <div className="metric-value">{activityCount}</div>
                                                        <div className="metric-icon activities-icon"></div>
                                                    </div>
                                                    
                                                    <div className="metric-box">
                                                        <div className="metric-title">APU</div>
                                                        <div className="metric-value">
                                                            {userCount ? (activityCount / userCount).toFixed(1) : 0}
                                                        </div>
                                                        <div className="metric-subtitle">Activities per user</div>
                                                        <div className="metric-icon apu-icon"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        )} */}
                                    </div>

                                    <div className="row">

                                        <div className="subsection activity last-activity">
                                            <div className="title">Last activity</div>
                                            <div className="value">{lastActivity}</div>
                                        </div>

                                        { (QRCodeAnalytics.length > 0) &&

                                            <div className="subsection qr-code">
                                                <div className="title">QR Code Analytics</div>
                                                <div className="stats qr-stats">


                                                            {QRCodeAnalytics.map((item, index) => (

                                                                <table key={index}>
                                                                    <tbody>
                                                                        <tr className="b">
                                                                            <td>{item.name}: &nbsp;{item.count}</td><td></td><td><div className={isShowMore[index] ? "show-more active" : "show-more"} onClick={() => { toggleShowMore(index) }}> </div></td>
                                                                        </tr>

                                                                        {isShowMore[index] &&
                                                                            <tr>
                                                                                <td colSpan="3">

                                                                                {item.results.map((person, personIndex) => (

                                                                                    <table className="stats-persons" key={personIndex}>
                                                                                        <tbody>
                                                                                            <tr>
                                                                                                <td>time: </td><td>{person.time_timezone_aware}</td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td>location: </td><td>{person.location}</td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td>device: </td><td>{person.device}</td>
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>

                                                                                ))}
                                                                                </td>
                                                                            </tr>
                                                                        }
                                                                    </tbody>
                                                                </table>

                                                            ))}


                                                </div>
                                            </div>
                                        }



                                        {/*
                                        <div className="subsection time">
                                            <div className="title">Average time spent</div>
                                            <div className="value">32min</div>
                                        </div>
                                        */}

                                    </div>




                                </section>
                            </div>
                            <div className="column column_leaderboard">
                                <section className="section_leaderboard">
                                    <h2>Users leaderboard</h2>

                                    <div className="users">

                                        {users.map((user, index) => (

                                            (index < 6) &&

                                            <div className="user" key={user.id}>
                                                <div className="number"><div>{index + 1}</div></div>
                                                <div className="image"><img className="avatar" src={user.avatarUrl} alt="avatar" /></div>
                                                <div>
                                                    <div className="name">{user.firstName}{" "}
                                                        <span className={`${user.lastName === "" ? "hide-last" : ""}`}>
                                                            {user.lastName[0]}
                                                        </span>
                                                    </div>
                                                    <div className="points">{user.score} points</div>
                                                </div>
                                            </div>

                                        ))}

                                        {/*
                                        <div className="user">
                                            <div className="number"><div>1</div></div>
                                            <div className="image"><img src={user} /></div>
                                            <div>
                                                <div className="name">Canelo Alvarez</div>
                                                <div className="points">75.2 points</div>
                                            </div>
                                        </div>
                                        <div className="user">
                                            <div className="number"><div>2</div></div>
                                            <div className="image"><img src={user} /></div>
                                            <div>
                                                <div className="name">Canelo Alvarez</div>
                                                <div className="points">75.2 points</div>
                                            </div>
                                        </div>
                                        <div className="user">
                                            <div className="number"><div>3</div></div>
                                            <div className="image"><img src={user} /></div>
                                            <div>
                                                <div className="name">Canelo Alvarez</div>
                                                <div className="points">75.2 points</div>
                                            </div>
                                        </div>
                                        <div className="user">
                                            <div className="number"><div>4</div></div>
                                            <div className="image"><img src={user} /></div>
                                            <div>
                                                <div className="name">Canelo Alvarez</div>
                                                <div className="points">75.2 points</div>
                                            </div>
                                        </div>
                                        <div className="user">
                                            <div className="number"><div>5</div></div>
                                            <div className="image"><img src={user} /></div>
                                            <div>
                                                <div className="name">Canelo Alvarez</div>
                                                <div className="points">75.2 points</div>
                                            </div>
                                        </div>
                                        <div className="user">
                                            <div className="number"><div>6</div></div>
                                            <div className="image"><img src={user} /></div>
                                            <div>
                                                <div className="name">Canelo Alvarez</div>
                                                <div className="points">75.2 points</div>
                                            </div>
                                        </div>
                                        <div className="user">
                                            <div className="number"><div>7</div></div>
                                            <div className="image"><img src={user} /></div>
                                            <div>
                                                <div className="name">Canelo Alvarez</div>
                                                <div className="points">75.2 points</div>
                                            </div>
                                        </div>
                                        */}
                                    </div>
                                </section>

                            </div>
                        </div>


                    </div>
                </main>
                :

                <>
                </>
            }

            <Footer />

        </div>

    )

}
